module.exports = __webpack_public_path__ + "img/flecha-volver.b9ee5113.svg";